export default __webpack_public_path__ + "static/media/DSC_8191-edited.39611e6a.jpg";